
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { AIDisclosureState } from '../types';
import type { Disposable } from '@patsnap/tahiti-core';

export const AIDisclosureModel = Symbol('AIDisclosureModel');

export interface AIDisclosureModel extends AbstractModel<AIDisclosureState>, Disposable { }
